const Selector = props => (
  <svg {...props} width="15px" height="15px" viewBox="0 0 15 15">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-178.000000, -96.000000)">
      <g id="Select" transform="translate(167.000000, 86.000000)" fill="#313F4C">
        <polygon id="Page-1-Copy-3" transform="translate(18.500000, 17.500000) scale(-1, 1) translate(-18.500000, -17.500000) " points="11 10 15.8739836 25 18.7134975 19.1978512 22.9093245 23.3380992 24.3167947 21.9250744 20.1199626 17.7848264 26 15.0082149"></polygon>
      </g>
    </g>
  </svg>
);

export default Selector;
